import { render, staticRenderFns } from "./FinancialDimensionEditDialog.vue?vue&type=template&id=4381eb3c"
import script from "./FinancialDimensionEditDialog.vue?vue&type=script&lang=js"
export * from "./FinancialDimensionEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports